/**
 * Static asset directories, served from the app's own public/ folder.
 *
 * These are paths, not URLs, and they are relative to the site root so the app
 * works unchanged behind any hostname.
 */
export const paths = {
    images: "/images",
    logos: "/images/logos",
    icons: "/Icons",
    svgs: "/Svg",
    audio: "/audio",
} as const;

export default paths;
